import { Component, inject } from '@angular/core';
import { AuthService } from '../../../../../../core/services/auth/auth.service';
import { HeaderPopupBase } from '../../classes/header-popup-base';
import { NgIf } from '@angular/common';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { PopupModule } from '@progress/kendo-angular-popup';
import { IconComponent } from '../../../icon/icon.component';
import { TranslatePipe } from '../../../../../pipes/translate/translate.pipe';
import { environment } from '../../../../../../../environments/environment';
import { UserSettingsApiService } from 'src/app/api/bizzmine/user-settings/user-settings-api.service';
import { UserSettingsDto } from 'src/models/ts/user-settings-dto.model';
import { PwaService } from 'src/app/core/services/pwa/pwa.service';
import { SidebarService } from '../../../../../services/sidebar/sidebar.service';
import { BreakpointEnum } from 'src/app/shared/enums/pixel-breakpoints';


@Component({
  selector: 'bizz-header-user',
  templateUrl: './header-user.component.html',
  styleUrls: ['./header-user.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    RouterLink,
    PopupModule,
    IconComponent,
    TranslatePipe,
  ],
})
export class HeaderUserComponent extends HeaderPopupBase {
  public userSettings: UserSettingsDto;

  public activatedRoute = inject(ActivatedRoute);

  public override togglePopup(value?: boolean): void {
    if (window.innerWidth < BreakpointEnum.SM) {
      this.sidebarService.collapseSidebar();
    }
    this.showPopup = value != undefined ? value : !this.showPopup;
  }

  private getUserSettings(): void {
    this.userSettingsApiService.getUserSettings().subscribe(settings => {
      this.userSettings = settings;
    })
  }

  public logout(): void {
    if(!this.pwaService.isOnline) this.togglePopup(false);
    this.authService.logoutViaIdentityServer();
  }

  public openHelpCenter(): void {
    window.open('https://portal.bizzmine.com/', '_blank');
  }

  public openSupport(): void {
    window.open("https://www.bizzmine.com/en/supportticket", "_blank");
  }

  public constructor(
    private sidebarService: SidebarService,
    private authService: AuthService,
    private userSettingsApiService: UserSettingsApiService,
    public pwaService: PwaService,
    private router: Router,
  ) {
    super();
    this.getUserSettings();
  }

  public getReturnUrl(): object {
    return { returnUrl : window.location.href }
  }

  protected readonly environment = environment;
}
